module.exports = __webpack_public_path__ + "static/assets/lucide-scan-face.svg";